// This file is used for maintain and manage API services.
(function () {
  'use strict';
  angular.module('obex').
  factory('profileFieldService', ['$http', '$q', 'obexConstant', 'authService',
    function ($http, $q, obexConstant, authService) {
      return {
        addProfileField(profileField) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const postData = {
              OrganizationId: profileField.OrganizationId,
              Column: parseInt(profileField.ProfileColumn),
              Name: profileField.GdsFieldName,
              AgencyDefinition: profileField.ProfileFieldName,
              IsRequired: profileField.IsRequired              
            };
            const url = `${obexConstant.urlProfileFields}`;            
            return $http.post(url, postData, {
              headers: authHeader,
            });
          });
        },

        addProfileFieldOption(profileFieldId, profileFieldOptionList) {
          const promises = _.map(profileFieldOptionList, profileFieldOption => {
            return authService.getAuthorizationHeader().then(authHeader => {
              const url = `${obexConstant.urlProfileFieldOptions}`;
              const postData = {
                Id: profileFieldOptionList.Id,
                Name: profileFieldOption.Name,
                profileFieldId: profileFieldId,
              };              
              return $http.post(url, postData, {
                headers: authHeader,
              });
            });
          });
          return $q.all(promises);
        }, // Defaults to get all profile fields when orgId is undefined

        getProfileFieldsByOrgId(orgId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = obexConstant.urlProfileFields + '/organization/' + orgId;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },

        updateProfileField(newProfileField) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const id = newProfileField.Id;
            const putData = {
              Id: id,
              OrganizationId: newProfileField.OrganizationId,
              Name: newProfileField.GdsFieldName,
              AgencyDefinition: newProfileField.ProfileFieldName,
              Column: newProfileField.ProfileColumn,
              IsRequired: newProfileField.IsRequired,
            };
            const url = `${obexConstant.urlProfileFields}/${id}`;
            return $http.put(url, putData, {
              headers: authHeader,
            });
          });
        },

        updateProfileFieldOption(id, ProfileFieldOptionList) {
          const promises = _.map(ProfileFieldOptionList, profileFieldOption => {
            return authService.getAuthorizationHeader().then(authHeader => {
              if (!!profileFieldOption.Id) {
                const url = `${obexConstant.urlProfileFieldOptions}/${profileFieldOption.Id}`;
                const putData = {
                  Id: profileFieldOption.Id,
                  Name: profileFieldOption.Name,
                  ProfileFieldId: profileFieldOption.ProfileFieldId,
                };
                return $http.put(url, putData, {
                  headers: authHeader,
                });
              } else {               
                const url = `${obexConstant.urlProfileFieldOptions}`;
                const postData = {
                  Id: profileFieldOption.Id,
                  Name: profileFieldOption.Name,
                  ProfileFieldId: profileFieldOption.ProfileFieldId,
                };
                return $http.post(url, postData, {
                  headers: authHeader,
                });
              }
            });
          });
          return $q.all(promises);
        },

        deleteProfileField(fieldId) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = obexConstant.urlProfileFields + '/' + fieldId;
            return $http.delete(url, {
              headers: authHeader,
            });
          });
        },

        deleteProfileFieldOption(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = obexConstant.urlProfileFieldOptions + '/' + id;
            return $http.delete(url, {
              headers: authHeader,
            });
          });
        },
      };
    },
  ]);
})();


// WEBPACK FOOTER //
// ./client/js/services/profileField.service.js